import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { axiosProperty, throwResponse } from "config/axios";
import { IDashboardParams } from "service/dashboard/interface";
import {
  IPropertyDashboardGraph,
  IPropertyMenuRecord,
  IPropertyMenuRecordWeb,
} from "./interface";

export const postMenuRecord = async (data: IPropertyMenuRecord) => {
  const res = await axiosProperty.get("/menu-records");
  if (res.status === 200) {
    return res.data;
  }
  throwResponse(res);
  return res.data;
};

export const useGetPropertyDashboardWeb = (
  params?: IDashboardParams
): UseQueryResult<IPropertyMenuRecordWeb, Error> => {
  return useQuery(
    ["dashboard-property-web-record", params],
    async () => {
      const res = await axiosProperty.get("/dashboard/menu/records-web", {
        params,
      });
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const useGetPropertyDashboardAppTeamUp = (
  params?: IDashboardParams
): UseQueryResult<IPropertyMenuRecordWeb, Error> => {
  return useQuery(
    ["dashboard-property-app-team-up-record", params],
    async () => {
      const res = await axiosProperty.get(
        "/dashboard/menu/records-app-juristic",
        {
          params,
        }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const useGetPropertyDashboardAppSmoothUp = (
  params?: IDashboardParams
): UseQueryResult<IPropertyMenuRecordWeb, Error> => {
  return useQuery(
    ["dashboard-property-app-smooth-up-record", params],
    async () => {
      const res = await axiosProperty.get(
        "/dashboard/menu/records-app-residents",
        {
          params,
        }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const useGetPropertyDashboardAppSummary = (
  params?: IDashboardParams
): UseQueryResult<IPropertyMenuRecordWeb, Error> => {
  return useQuery(
    ["dashboard-property-summary-record", params],
    async () => {
      const res = await axiosProperty.get("/dashboard/menu/records-summary", {
        params,
      });
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const useGetPropertyDashboardGraph = (
  params?: IDashboardParams
): UseQueryResult<IPropertyDashboardGraph[], Error> => {
  return useQuery(
    ["dashboard-property-graph-record", params],
    async () => {
      const res = await axiosProperty.get("/dashboard/menu/records-graph", {
        params,
      });
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};
